// Set up your root reducer here...
 import { combineReducers } from 'redux';
import {routerReducer} from 'react-router-redux';

const rootReducer = combineReducers({
    routing: routerReducer
});
 export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js